import {Box, Paper, Skeleton, Stack, Typography} from '@mui/material';
import {ReactNode} from 'react';

interface Props {
    title: string;
    value: string;
    hint: string;
    icon: ReactNode;
    loading?: boolean;
    tone?: 'default' | 'positive' | 'negative';
}

const toneColors = {
    default: {background: '#F5E7DF', color: '#8F5338'},
    positive: {background: '#E8F3EC', color: '#2E7D4F'},
    negative: {background: '#FDEAEA', color: '#B24646'},
};

export const FinanceSummaryCard = ({title, value, hint, icon, loading = false, tone = 'default'}: Props) => {
    const colors = toneColors[tone];

    return (
        <Paper sx={{p: 2.5, height: '100%'}}>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Box>
                    <Typography variant="body2" color="text.secondary" sx={{mb: 0.75}}>
                        {title}
                    </Typography>
                    {loading ? (
                        <Skeleton width={130} height={38}/>
                    ) : (
                        <Typography variant="h2" sx={{fontSize: {xs: '1.6rem', md: '1.85rem'}}}>
                            {value}
                        </Typography>
                    )}
                </Box>
                <Box
                    sx={{
                        width: 42,
                        height: 42,
                        borderRadius: 2.5,
                        display: 'grid',
                        placeItems: 'center',
                        backgroundColor: colors.background,
                        color: colors.color,
                        flexShrink: 0,
                    }}
                >
                    {icon}
                </Box>
            </Stack>
            <Typography variant="caption" sx={{display: 'block', mt: 1.25}}>
                {hint}
            </Typography>
        </Paper>
    );
};
